import { LoginForm } from "~/features/login/ui/login.form";

export const LoginPage = () => {
  return <LoginForm />;
};
